const state = {
	selections: {}
};

const mutations = {
	SET_REGION(state, { scopeKey, region }) {
		state.selections = {
			...state.selections,
			[scopeKey]: {
				region,
				timestamp: Date.now()
			}
		};
	},

	CLEAR_REGION(state, scopeKey) {
		const { [scopeKey]: _, ...rest } = state.selections;
		state.selections = rest;
	}
};

const getters = {
	getRegion: state => scopeKey => {
		return state.selections[scopeKey]?.region;
	}
};

const actions = {
	setRegion({ commit }, payload) {
		commit('SET_REGION', payload);
	},

	clearRegion({ commit }, scopeKey) {
		commit('CLEAR_REGION', scopeKey);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
};
